exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeviceSelection{margin:0 auto;width:288px}.DeviceSelection-header{font-size:24px;font-weight:500;margin-bottom:40px}.DeviceSelection-subHeader{font-size:14px;font-weight:400;margin-top:4px;letter-spacing:-0.2px}.DeviceSelection-NotCompatableModal{width:400px}@media only screen and (max-width: 420px){.DeviceSelection-NotCompatableModal{width:288px}}.DeviceSelection-NotCompatableModal-body{font-size:14px}", ""]);

// exports
